import { render, staticRenderFns } from "./btnCategoryEdit.vue?vue&type=template&id=75c8c141"
import script from "./btnCategoryEdit.vue?vue&type=script&lang=js"
export * from "./btnCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports